var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-chip-group',{attrs:{"column":""}},_vm._l((_vm.subCategories),function(subCategory,index){return _c('v-chip',{key:index,attrs:{"dark":"","label":"","to":{ name: 'booking-public-event', params: { category: _vm.category, subCategory } }}},[_vm._v(" "+_vm._s(subCategory)+" ")])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }